<script setup lang="ts">
import { useClipboard } from "@vueuse/core";
import NovaButton from "../NovaButton/NovaButton.vue";
import NovaIcon from "../NovaIcon/NovaIcon.vue";

const props = defineProps<{ modelValue: string; toastMessage?: string }>();

const { copy, isSupported, copied } = useClipboard({ copiedDuring: 4000 });
const notificationStore = useNotifications();
const { $t } = useNuxtApp();

const handleCopy = async () => {
  if (!isSupported.value) {
    notificationStore.addNotification({
      title: "Error copying to clipboard",
      type: "toast",
      theme: "error",
      message: "Your browser does not support Clipboard API",
    });
    return;
  }

  await copy(props.modelValue);

  notificationStore.addNotification({
    title: $t("copy-to-clipboard.notification-success.title"),
    type: "toast",
    theme: "success",
    message: props.toastMessage || $t("common.copied"),
  });
};
</script>

<template>
  <div class="flex items-center text-text-90 text-xs font-normal border border-neutral-60 rounded-lg p-2 w-fit">
    <p class="mr-2">
      <slot :text="modelValue">
        {{ modelValue }}
      </slot>
    </p>
    <NovaButton
      variant="outline"
      size="xs"
      class="w-20"
      data-testid="nova-copy-to-clipboard-button"
      @click="handleCopy"
    >
      <div v-show="copied" class="flex items-center">
        <NovaIcon name="check" class="mr-1" :size="12" />
        <span>{{ $t("common.copied") }}</span>
      </div>

      <div v-show="!copied" class="flex items-center">
        <NovaIcon name="copy" class="mr-2" :size="12" />
        <span>{{ $t("common.copy") }}</span>
      </div>
    </NovaButton>
  </div>
</template>
